'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = require('rp-react-svg-icon');

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _clamper = require('clamper');

var _clamper2 = _interopRequireDefault(_clamper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The option from the list.
 */
var SelectOption = function (_PureComponent) {
    _inherits(SelectOption, _PureComponent);

    function SelectOption(props) {
        _classCallCheck(this, SelectOption);

        var _this = _possibleConstructorReturn(this, (SelectOption.__proto__ || Object.getPrototypeOf(SelectOption)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(SelectOption, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _clamper2.default)(this.labelRef, { clamp: 2 });
        }
    }, {
        key: 'handleClick',
        value: function handleClick() {
            var _props = this.props,
                option = _props.option,
                valueGetter = _props.valueGetter,
                onClick = _props.onClick,
                immediateUpdate = _props.immediateUpdate;

            onClick(valueGetter(option), option);

            if (immediateUpdate) {
                this.forceUpdate();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                option = _props2.option,
                labelGetter = _props2.labelGetter,
                isSelected = _props2.isSelected;

            return _react2.default.createElement(
                'div',
                {
                    onClick: this.handleClick,
                    className: (0, _classnames2.default)('sb-selectList__option', 'ui-popoverList__link', { 'sb-selectList__option_selected': isSelected(option) })
                },
                _react2.default.createElement(
                    'span',
                    {
                        className: 'sb-selectList__label',
                        ref: function ref(_ref) {
                            return _this2.labelRef = _ref;
                        }
                    },
                    labelGetter(option)
                ),
                _react2.default.createElement(_rpReactSvgIcon2.default, {
                    iconName: 'tick',
                    size: 'Medium'
                })
            );
        }
    }]);

    return SelectOption;
}(_react.PureComponent);

SelectOption.propTypes = {
    /**
     * The option to render.
     * It has no mandatory structure.
     * You can pass any object with custom label and value getters.
     */
    option: _react.PropTypes.object.isRequired, // eslint-disable-line
    /**
     * The option label getter.
     * It is used to display the option.
     */
    labelGetter: _react.PropTypes.func.isRequired,
    /**
     * The option value getter.
     * It is used to pass the value to the onClick handler.
     */
    valueGetter: _react.PropTypes.func.isRequired,
    /**
     * Function to check is option selected.
     * It is used to highlight the selected option.
     */
    isSelected: _react.PropTypes.func.isRequired,
    /**
     * The 'click' event handler.
     * It gets option value and the option itself as arguments.
     */
    onClick: _react.PropTypes.func.isRequired,
    /**
     * Property for immediate option re render on selection
     */
    immediateUpdate: _react.PropTypes.bool
};

exports.default = SelectOption;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-select/lib/js/components/SelectOption.js
// module id = 2779
// module chunks = 0